(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/prescript.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/prescript.js');
'use strict';

svs.termsIntegrity = svs.termsIntegrity || {};
svs.termsIntegrity.actions = svs.termsIntegrity.actions || {};
svs.termsIntegrity.constants = svs.termsIntegrity.constants || {};
svs.termsIntegrity.integrity = svs.termsIntegrity.integrity || {};
svs.termsIntegrity.rules = svs.termsIntegrity.rules || {};
svs.termsIntegrity.terms = svs.termsIntegrity.terms || {};
svs.termsIntegrity.store = svs.termsIntegrity.store || {};
svs.termsIntegrity.store.actions = svs.termsIntegrity.store.actions || {};
svs.termsIntegrity.store.actiontypes = svs.termsIntegrity.store.actiontypes || {};
svs.termsIntegrity.sharedComponents = svs.termsIntegrity.sharedComponents || {};

svs.termsIntegrity.logger = new svs.core.log.Logger('module:terms-integrity');


 })(window);